import { Spine, IAnimation } from "pixi-spine";
import { SpineSymbolConfig } from "slotworks/config/spine-config-schema";

export default class ExtendedSpine extends Spine {
    public x: number;
    public y: number;

    public scale: { x: number, y: number } = { x: 1, y: 1 };

    public name: string = "";
    private config: SpineSymbolConfig;
    public visible: boolean;

    public constructor(data: any, config: SpineSymbolConfig = null) {
        super(data);
        this.config = config;
    }

    public setSkin(name: string) {
        this.skeleton.setSkinByName(name);
        this.skeleton.setSlotsToSetupPose();
    }

    public getSkin() {
        return this.skeleton.skin.name;
    }

    public hasAnimation(animation: string) {
        if (this.config && this.config[animation as keyof SpineSymbolConfig] && 
                this.state.hasAnimation(this.config[animation as keyof SpineSymbolConfig] as string))
            return true;
        return this.state.hasAnimation(animation);
    }

    public play(slot: number = 0, animation: string, loop: boolean = false) {
        if(this.config) {
            const inConfig = this.config[animation as keyof SpineSymbolConfig];
            if (inConfig) {
                animation = inConfig as string;
            }
        }
        this.state.setAnimation(slot, animation, loop);
    }

    public stop() {
        this.skeleton.setToSetupPose();
        this.state.clearTracks();
        this.state.tracks = [];
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/graphics/spine/spine.ts